import { Newspaper, Package, CupSoda, Wrench, Smartphone, Wine, BookOpen, Milk } from "lucide-react";
import { t } from "@/lib/i18n";

const ITEMS = [
  { icon: Newspaper, label: "Newspaper" }, { icon: BookOpen, label: "Books & copies" },
  { icon: Package, label: "Cardboard" }, { icon: Milk, label: "Plastic bottles" },
  { icon: CupSoda, label: "Aluminium cans" }, { icon: Wrench, label: "Iron & steel" },
  { icon: Smartphone, label: "Old electronics" }, { icon: Wine, label: "Glass bottles" },
];

export default function MaterialsMarquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <section className="border-y border-[rgba(20,40,26,.08)] bg-white overflow-hidden" data-testid="materials-marquee">
      <div className="flex w-max marquee py-5">
        {row.map(({ icon: Icon, label }, i) => (
          <div key={i} className="flex items-center gap-3 px-8 text-[var(--ink)]">
            <Icon size={20} className="text-[var(--leaf)]" />
            <span className="font-display text-lg font-semibold whitespace-nowrap">{t(label)}</span>
            <span className="ml-8 w-1.5 h-1.5 rounded-full bg-[var(--marigold)]" />
          </div>
        ))}
      </div>
    </section>
  );
}
